'use es6';

import * as ConnectionType from '../constants/ConnectionType';
export const getIsStandardConnection = connectionType => {
  return connectionType === ConnectionType.STANDARD;
};
export const getIsHomemadeIframeConnection = connectionType => {
  return connectionType === ConnectionType.HOMEMADE_IFRAME;
};
export const getIsHomemadeExternalConnection = connectionType => {
  return connectionType === ConnectionType.HOMEMADE_EXTERNAL;
};
export const getIsHomemadeModalConnection = connectionType => {
  return connectionType === ConnectionType.HOMEMADE_MODAL;
};